//////////////////////////////////////////////////

// change `no-js` to `js` in header (taken from Modernizr)
(function() {
	var className = document.documentElement.className;
	var reJS = new RegExp('(^|\\s)no-js(\\s|$)');
	document.documentElement.className = className.replace(reJS, '$1js$2');

	//////////////////////////////////////////////////
	// Fix for IE 10 issues
	document.documentElement.setAttribute('data-useragent', navigator.userAgent);
}());

// smooth scroll to anchor links
(function() {
	$(document).on('click', 'a[href^="#"]', function(event) {
		event.preventDefault();
		var href = $(this).attr('href');
		var elem = $(href);
		var top = (elem && elem.length > 0) ? elem.offset().top : 0;
		if ($(window).width() >= 1024) {
			top -= $('header').outerHeight();
		}
		$('html, body').animate({
			scrollTop: top
		}, 500);

	});
}());

// wow animations
(function() {
	var wow = new window.WOW({
		boxClass:		'wow',
		animateClass:	'animated',
		offset:			0,
		mobile:			true,
		live:			true
	});
	wow.init();
}());


// lazy load images
(function() {
	window.lazyLoader = new window.LazyLoad({elements_selector: ".lazy"});
}());

// resource center mobile dropdown toggle
(function() {
	var mobileDropdownToggleElement = document.body.querySelector('#resourceCenterMobileDropdownToggle');
	var mobileDropdownElement = document.body.querySelector('.mobile__dropdown')
	if (mobileDropdownToggleElement) {
		mobileDropdownToggleElement.addEventListener('click', function (event) {
			if (mobileDropdownElement.classList.contains('mobile__dropdown--expanded')) {
				mobileDropdownElement.classList.remove('mobile__dropdown--expanded');
				mobileDropdownElement.classList.add('mobile__dropdown--hidden');
			} else {
				mobileDropdownElement.classList.remove('mobile__dropdown--hidden');
				mobileDropdownElement.classList.add('mobile__dropdown--expanded');
			}
		})
	}
}());

// cross-sell modal
(function() {
	$('#modal-open, #modal-close').on('click', function() {
		$('body').toggleClass('modal-open');
	});

	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		$('.cross-sell--modal').toggleClass('modal-success');
		$('#modal-title').css('display', 'none');
		$('#modal-text').css('display', 'none');
		$('#modal-close').text('Close');
	});
}());

